import React from 'react';
import { getValueSafely } from 'utils/utils';
import errorIcon from 'assets/icons/error-2.svg';
import { LOW_BATTERY_THRESHOLD } from 'config/constants';
import TableCellWarning from 'components/DataTable/cells/TableCellWarning';
import { format } from 'date-fns';
import { Asset } from 'types/asset';

export default function BatterySpan({ asset }: { asset: Asset }) {
  if (!asset.assigned_beacon || !asset.assigned_beacon.battery) return <>––</>;
  const hasTimestamp = asset.last_location_update_timestamp !== null;

  if (asset.assigned_beacon.battery <= LOW_BATTERY_THRESHOLD) {
    return (
      <TableCellWarning>
        {getValueSafely(asset.assigned_beacon.battery, '%')}
        <img
          id="low-battery-icon"
          style={{
            marginLeft: '5px',
            width: '20px',
          }}
          src={errorIcon}
          alt="low battery"
        />
        {hasTimestamp && (
          <span style={{ color: 'black', marginLeft: '10px' }}>
            {`  (${format(
              new Date(asset.last_location_update_timestamp),
              'dd/MM/yyyy - HH:mm',
            )})`}
          </span>
        )}
      </TableCellWarning>
    );
  } else {
    return (
      <span className="u-no-pointer-event">
        {getValueSafely(asset.assigned_beacon.battery, '%')}
        {hasTimestamp && (
          <span style={{ color: 'black', marginLeft: '10px' }}>
            {`  (${format(
              new Date(asset.last_location_update_timestamp),
              'dd/MM/yyyy - HH:mm',
            )})`}
          </span>
        )}
      </span>
    );
  }
}
